export default "__VITE_ASSET__X0FClZC5__"